export default [
  {
    type: 'selection',
    width: 55,
    show: true,
  },
  {
    title: '编号',
    key: 'id',
    minWidth: 40,
    maxWidth: 100,
    show: true,
  },
  {
    title: '平台',
    key: 'platform',
    slot: 'platform',
    show: true,
  },
  {
    title: '版本号',
    key: 'version_no',
    show: true,
  },
  {
    title: '下载地址',
    key: 'download_url',
    show: true,
  },
  {
    title: '是否强制更新',
    key: 'force_update',
    slot: 'force_update',
    show: true,
  },
  {
    title: '状态',
    key: 'status',
    slot: 'status',
    show: true,
  },
  {
    title: '操作',
    key: 'action',
    slot: 'action',
    width: 120,
    align: 'center',
    fixed: 'right',
    show: true,
  },
]
